'use strict';

class MobileRecharge {
	constructor(options) {
		//console.log('MobileRecharge(%o)', options);
		this.o = {
			operators_per_row: 4,
			mr_hero_max_operators: 6,
			target_hero_max_operators: 3,
			location: null,
			tracking_params: {
				banners: {}
			},
			new_value_promo_format: false,
			operators_back_btn_text: '',
		};
		this.c = {};
		this.ajax = {};
		this.promise = {};
		this.fields = {
			holder: null,
			form: null,
			country: null,
			operator_holder: null,
			phone_number_holder: null,
			amount_holder: null,
			send_sms_holder: null,
			send_sms_phone_number: null,
			send_sms_mask_helper: null,
			send_sms_notify_label: null,
			submit_holder: null,
			submit_message_holder: null,
			operator_content: null,
			operator_banner_holder: null,
			operator_banner_content: null,
			amount_content: null,
			amount_banner_holder: null,
			amount_banner_content: null,
			amount_custom_range_input: null,
			phone_prefix: null,
			phone_number: null,
			phone_mask_helper: null,
			phone_error_message: null,
			form_fields: null,
			send_sms_notify_dest: null,
			all_operators_holder: null,
			operator_options_content: null,
			nickname_fields_holder: null
		};

		this.fields = Object.assign(this.fields, options.fields);
		this.o = Object.assign(this.o, options.o);
		this.base_url = options.base_url;
		this.add_tello_as_operator = options.add_tello_as_operator;

		if (this.fields.operator_banner_content) {
			this.fields.operator_banner_content.style.display = 'none';
		}
		if (this.base_url !== 'send') {
			this.fields.phone_number_holder.hide();
		}
		this.fields.amount_holder.hide();
		this.fields.send_sms_holder.hide();

		this.ACCOUNT_TYPES = {
			PHONE: "phone",
			EMAIL: "email"
		}
		this.account_type = this.ACCOUNT_TYPES.PHONE;

		this.state = {
			'country': {},
			'operator': {},
			'phone_number': {},
			'amount': {},
			'sms_phone_number': {}
		};
		this.state = Object.assign(this.state, options.state);
		this.bindEvents();
	}

	changeCountry(country_code) {
		let that = this;
		//console.log('changeCountry(%o)', country_code, that.state);

		$('.spinner', that.fields.operator_holder).show();
		that.fields.operator_holder.show();

		return new Promise((resolve, reject) => {
			that.state.country.code = country_code;
			that.state.phone_number = {};
			that.state.amount = {};
			that.state.operator = {};

			that.fields.country.val(that.state.country.code);
			that.state.country.name = $('option:selected', that.fields.country).attr('data-country');

			// stop unnecessary requests
			if (that.ajax.get_distinct_operators) {
				that.ajax.get_distinct_operators.abort();
			}
			if (that.ajax.get_received_amount) {
				that.ajax.get_received_amount.abort();
			}

			// clean fields
			//that.fields.operator_holder.hide();
			if (that.base_url !== 'send') {
				that.fields.phone_number_holder.hide();
			}
			that.fields.amount_holder.hide();
			that.fields.send_sms_holder.hide();
			if (that.fields.submit_message_holder) {
				that.fields.submit_message_holder.text('');
			}
			that.fields.submit_holder.find('button[type=submit]').addClass('disabled');

			that.fields.amount_content.empty();
			if (that.base_url !== 'send') {
				that.fields.operator_content.empty();
				if (that.fields.operator_banner_content) {
					that.fields.operator_banner_content.innerHTML = '';
				}
			}

			if (that.state.country.name) {
				// used on KC
				s.track.dataLayerPush({
					'event': 'gtm_remarketing',
					'destination': that.state.country.name,
					'dynx_pagetype': 'searchresults'
				});
			}

			if (that.c[that.state.country.code]) {
				resolve({
					'state': that.state,
					'operator_groups': that.c[that.state.country.code]
				});
			} else {
				if (that.state.country.code === '') {
					resolve({
						'state': that.state,
						'operator_groups': []
					});
				} else {
					let params = {
						'action': 'get_distinct_operators_v4',
						'country_code': that.state.country.code,
					};

					if (that.o.banner_promo_code != '') {
						params.banner_promo_code = that.o.banner_promo_code;
					}
					that.ajax.get_distinct_operators = $.ajax({
						'method': 'GET',
						'url': s.url('/buy/mobile_recharge_checks'),
						'data': params
					})
						.done((operator_groups) => {
							resolve({
								'state': that.state,
								'operator_groups': operator_groups
							});
						})
						.fail((err) => {
							reject({
								'state': that.state,
								'status': false,
								'err': err
							});
						});
				}
			}
		})
			.then((response) => {
				//console.log('changeCountry(%o).then(%o)', response, that.state);
				that.c[that.state.country.code] = response.operator_groups;
				$('.spinner', that.fields.operator_holder).hide();

				return response;
			})
			.catch((response) => {
				//console.log('changeCountry(%o).then(%o)', response, that.state);
				$('.spinner', that.fields.operator_holder).hide();

				throw response;
			});
	}

	changeOperator(operator_id) {
		let that = this;
		//console.log('changeOperator(%o)', operator_id, that.state);

		return new Promise((resolve, reject) => {
			that.fields.send_sms_holder.hide();
			that.fields.submit_holder.find('button[type=submit]').addClass('disabled');

			// stop unnecessary requests
			if (that.ajax.get_received_amount) {
				that.ajax.get_received_amount.abort();
			}

			// TODO change this to proper objects
			if (that.base_url !== '') {
				$('.operator', that.fields.operator_content)
					.removeClass('active')
					.addClass('inactive d-none d-sm-block');
			} else {
				$('.operator', that.fields.operator_content)
					.removeClass('active')
					.addClass('inactive');
			}
			let group_select = $('.operator select option[value="' + s.h(operator_id) + '"]', that.fields.operator_content);
			if (group_select.length) {
				if (that.base_url !=='') {
					group_select
						.closest('select')
						.val(operator_id)
						.closest('.operator')
						.removeClass('inactive d-none d-sm-block')
						.addClass('active');
				} else {
					group_select
						.closest('select')
						.val(operator_id)
						.closest('.operator')
						.removeClass('inactive')
						.addClass('active');
				}
			} else {
				if (that.base_url !== '') {
					$('.operator_button[value="' + s.h(operator_id) + '"]', that.fields.operator_content)
						.closest('.operator')
						.removeClass('inactive d-none d-sm-block')
						.addClass('active');
				} else {
					$('.operator_button[value="' + s.h(operator_id) + '"]', that.fields.operator_content)
						.closest('.operator')
						.removeClass('inactive')
						.addClass('active');
				}
			}

			let operator_groups = that.c[that.state.country.code];
			let operator = null;
			for (let group_name in operator_groups) {
				if (operator_groups.hasOwnProperty(group_name)) {
					let group_details = operator_groups[group_name];

					for (let group_name in group_details.operators) {
						if (group_details.operators.hasOwnProperty(group_name)) {
							let _operator = group_details.operators[group_name];

							if (parseInt(_operator.id) === parseInt(operator_id)) {
								operator = _operator;

								break;
							}
						}
					}

					if (operator) {
						break;
					}
				}
			}

			if (!operator) {
				that.fields.amount_holder.hide();
				that.fields.amount_banner_holder.hide();
				that.fields.send_sms_holder.hide();
				that.fields.submit_holder.hide();
				that.fields.submit_holder.find('button[type=submit]').addClass('disabled');

				reject({
					'message': 'Invalid operator',
					'state': that.state
				});
			}

			that.state.operator = operator;
			that._handleDisplayOperatorBanners(operator);
			that.state.phone_number.regex = that.state.operator.number.regex;
			that.state.phone_number.mask = that.state.operator.number.mask;

			let sms_notification_mask =  that.state.operator?.sms_notification_data?.mask;
			if (sms_notification_mask) {
				that.state.sms_phone_number.mask = sms_notification_mask;
				let country_prefix = /^[^x-]+/gi.exec(that.state.sms_phone_number.mask);
				that.state.sms_phone_number.prefix = country_prefix ? country_prefix[0] : '';
			}

			if (typeof that.state.phone_number.number === 'undefined') {
				that.state.phone_number.number = '';
			}
			that.state.amount = null;

			let new_account_type = (operator?.operator_type.toLowerCase() === 'internet') ? that.ACCOUNT_TYPES.EMAIL : that.ACCOUNT_TYPES.PHONE;
			if (that.account_type !== new_account_type) {
				that.account_type = new_account_type;
				that.fields.phone_error_message?.hide();
				that.state.phone_number.number = '';
				that.fields.phone_number.val('');
				that.fields.send_sms_phone_number?.val('');
			}

			let phone_input_label = that.fields.phone_number_holder.find('label[for="phone_number"]');

			if (that.account_type === that.ACCOUNT_TYPES.PHONE) {
				let country_prefix = /^[^x-]+/gi.exec(that.state.operator.number.mask);
				country_prefix = country_prefix ? country_prefix[0] : '';
				that.state.phone_number.prefix = country_prefix;

				phone_input_label.html(s.it('PHONE_NUMBER:'));
				that.fields.phone_prefix.show();
				that.fields.phone_prefix.html(country_prefix);
				that.fields.phone_number.attr('placeholder', '');

				let full_number = that._sanitizePhoneNumber(that.state.phone_number.prefix + that.state.phone_number.number);
				that.fields.phone_mask_helper?.show();
				that.fields.phone_mask_helper?.html(that._formatPhoneExample(full_number));
				that.fields.nickname_fields_holder?.show();
			} else {
				phone_input_label.html(s.it('NAUTA_ACCOUNT'));
				that.fields.phone_prefix.hide();
				that.fields.phone_number.attr('type', 'email');
				that.fields.phone_number.attr('placeholder', s.it('NAUTA_EMAIL_FIELD'));
				that.fields.phone_mask_helper?.hide();
				that.fields.nickname_fields_holder?.hide();
			}

			// update url
			/*let new_url = that.base_url;
			new_url += '/' + encodeURIComponent(that.state.country.name);
			new_url += '/' + encodeURIComponent(that.state.operator.name);
			window.history.replaceState(this.state, 'Title', s.url(new_url));*/

			that.fields.phone_number_holder.show();

			that.fields.submit_holder.show();
			that.fields.submit_holder.find('button[type=submit]').addClass('disabled');
			if (that.fields.submit_message_holder) {
				that.fields.submit_message_holder.text('');
			}
			if (parseInt(operator.sms_notification)) {
				that.fields.send_sms_holder.show();
			}

			if (typeof that.o.tracking_params.banners[operator_id] !== 'undefined') {
				if (that.o.tracking_params.banners[operator_id].banner_type && that.o.tracking_params.banners[operator_id].banner_content) {
					s.track.event(
						`MR ${that.o.tracking_params.banners[operator_id].banner_type} Banner`,
						'Impressions',
						`${that.o.tracking_params.banners[operator_id].banner_type} ${that.o.tracking_params.banners[operator_id].banner_content}`
					);
				}
			}

			resolve({
				'state': that.state,
				'operator': operator
			});
		})
			.then((response) => {
				//console.log('changeOperator(%o).then(%o)', response, that.state);

				return response;
			})
			.catch((response) => {
				//console.log('changeOperator(%o).catch(%o)', response, that.state);

				throw response;
			});
	}

	_updateSendSmsNotify(phone_number) {
		let that = this;
		const sms_textarea = that.fields.send_sms_holder?.find('#sms-notify-message textarea');
		const sms_col_holder = that.fields.send_sms_holder?.find('#sms-notify-col-holder');
		const sms_phone_holder = that.fields.send_sms_holder?.find('#sms-notify-phone-holder');
		const sms_country_prefix = that.fields.send_sms_holder?.find('#sms-country-prefix');
		if (that.account_type === that.ACCOUNT_TYPES.PHONE) {
			that.fields.send_sms_notify_label?.html(s.it('SEND_NOTIFICATION_TO_MOBILE'));
			that.fields.send_sms_notify_label?.find('.notify_dest').html(phone_number);
			sms_textarea.attr('placeholder', s.it('MR_SEND_SMS_TEXT_EXAMPLE'));
			sms_col_holder.removeClass('col-md-6');
			sms_phone_holder.removeClass('d-flex').hide();
		} else {
			that.fields.send_sms_notify_label?.html(s.it('NAUTA_SMS', {'nauta_account': '<strong>' + phone_number + '</strong>'}));
			sms_textarea.attr('placeholder', s.it('NAUTA_SMS_TEXT'));
			sms_col_holder.addClass('col-md-6');
			sms_phone_holder.addClass('d-flex').show();
			if (that.state.sms_phone_number.prefix) {
				sms_country_prefix.html(that.state.sms_phone_number.prefix);
				that.fields.send_sms_mask_helper.html(that._formatSMSPhoneExample(''));
			}
		}
	}

	changePhoneNumber(phone_number) {
		let that = this;
		// console.log('changePhoneNumber(%o)', phone_number, that.state);
		let prefix = ''

		if (that.account_type === that.ACCOUNT_TYPES.PHONE) {
			phone_number = that._sanitizePhoneNumber(phone_number)
			prefix = that._sanitizePhoneNumber(that.state.phone_number.prefix);
		} else {
			phone_number = that._sanitizeAccountNumber(phone_number);
		}

		return new Promise((resolve, reject) => {
			that.state.phone_number.number = that.account_type === that.ACCOUNT_TYPES.PHONE ? phone_number.replace(prefix, '') : phone_number;
			that.fields.phone_number.val(that.state.phone_number.number);

			if (that.ajax.get_received_amount) {
				that.ajax.get_received_amount.abort();
			}

			that.fields.amount_banner_holder.hide();

			if (that.o.location === 'buy_page') {
				that._updateSendSmsNotify('');
			}

			let full_number = that.state.phone_number.number;
			if(that.account_type === that.ACCOUNT_TYPES.PHONE) {
				full_number = prefix + that.state.phone_number.number;
				that.fields.phone_mask_helper.html(that._formatPhoneExample(full_number));
			}

			if (new RegExp(that.state.operator.number.regex).test(full_number)) {
				resolve({
					'state': that.state
				});
			} else {
				reject({
					'state': that.state,
					'message': that.account_type === that.ACCOUNT_TYPES.PHONE ? 'Incorrect number format' : 'Incorrect account format',
					'number': full_number
				});
			}
		})
			.then((response) => {
				//console.log('changePhoneNumber(%o).then(%o)', phone_number, response, that.state);
				if (that.o.location === 'buy_page') {
					that._updateSendSmsNotify(that.state.phone_number.number);
				}

				// update url
				if (that.base_url !== 'send') {
					let new_url = that.base_url;
					new_url += '/' + encodeURIComponent(that.state.country.name);
					new_url += '/' + encodeURIComponent(that.state.operator.name);
					let params = {
						'destination': that.account_type === that.ACCOUNT_TYPES.PHONE
							? that.state.phone_number.prefix + that.state.phone_number.number
							: that.state.phone_number.number
					};
					if (that.o.banner_promo_code !== '') {
						params._banner = that.o.banner_promo_code;
					}

					window.history.replaceState(this.state, 'Title', s.url(new_url, params));
				}
				let amounts = $('.amount', that.fields.amount_content);
				amounts.prop({'disabled': false});
				amounts.attr({'data-disabled': false});

				$('#amount-custom-range-input', that.fields.holder).prop({'disabled': false});
				that.fields.submit_holder.find('button[type=submit]').addClass('disabled');

				if (that.fields.submit_message_holder) {
					that.fields.submit_message_holder.text('');
				}

				/* Dynamic Remarketing - used on MR */
				if (typeof response.state.country.name !== 'undefined' && typeof response.state.operator.name !== 'undefined') {
					s.track.dataLayerPush({
						'event': 'gtm_dynamic_remarketing',
						'google_tag_params': {
							'ecomm_prodid': response.state.country.name,
							'ecomm_pagetype': 'product',
							'ecomm_pcat': response.state.operator.name
						}
					});
				}

				if (that.state.amount !== null) {
					if (that.state.operator.value_type === 'fixed') {
						that.changeAmount(parseFloat(that.state.amount.local_value));
					} else {
						that.changeAmount(that.state.amount.sale_value);
					}
				}

				//select the first amount card
				if (amounts.length == 1) {
					amounts[0].click();
				}

				return {'state': that.state};
			})
			.catch((response) => {
				//console.log('changePhoneNumber(%o).catch(%o)', phone_number, response, that.state);
				that.fields.submit_holder.find('button[type=submit]').addClass('disabled');
				$('#amount-custom-range-input', that.fields.holder).prop({'disabled': true});
				$('.amount', that.fields.amount_content).prop({'disabled': true});
				$('.amount', that.fields.amount_content).attr({'data-disabled': true});

				throw response;
			});
	}

	_validateAmount(amount, operator) {
		let that = this;
		//console.log('_validateAmount(%o, %o)', amount, operator, that.state);
		let return_amount = null;

		return new Promise((resolve, reject) => {
			that.state.amount = {};
			switch (operator.value_type) {
				case 'fixed':
					$('.amount', that.fields.amount_content)
						.removeClass('active')
						.removeClass('inactive');
					that.state.operator.values.forEach((value) => {
						if (parseFloat(amount) === parseFloat(value.local_value)) {
							return_amount = value;
						}
					});
					if (return_amount) {
						// TODO change this to proper objects
						$('.amount', that.fields.amount_content).addClass('inactive');
						$('.amount[value="' + s.h(amount) + '"]', that.fields.amount_content)
							.removeClass('inactive')
							.addClass('active');

						$('.amount[data-value="' + s.h(amount) + '"]', that.fields.amount_content)
							.removeClass('inactive')
							.addClass('active');

						resolve({'amount': return_amount});
					} else {
						reject({
							'message': 'Invalid amount.',
							'amount': amount
						});
					}
					break;

				case 'range':
					that.fields.submit_holder.find('button[type=submit]').addClass('disabled');
					let min_amount = that.state.operator.values[0];
					let max_amount = that.state.operator.values[1];

					if (parseFloat(amount) >= parseFloat(min_amount.sale_value) && parseFloat(amount) <= parseFloat(max_amount.sale_value)) {
						$('.spinner', that.fields.amount_content).show();
						that.ajax.get_received_amount = $.ajax({
							'method': 'GET',
							'url': s.url('/buy/mobile_recharge_checks'),
							'data': {
								'action': 'get_received_amount',
								'operator_id': that.state.operator.id,
								'amount': amount
							}
						})
							.done(function(response) {
								$('.spinner', that.fields.amount_content).hide();
								if (response.status) {
									resolve({
										'status': response.status,
										'message': response.message,
										'amount': amount
									});
								} else {
									reject({
										'status': response.status,
										'message': response.message,
										'amount': amount
									});
								}
							})
							.fail(function(err) {
								$('.spinner', that.fields.amount_content).hide();
								reject({'message': ''});
							});
					} else {
						that.state.amount = null;

						reject({
							'message': 'Amount must be between '
								+ s.h(s.format_money(min_amount.sale_value))
								+ ' and '
								+ s.h(s.format_money(max_amount.sale_value)),
							'min': min_amount.sale_value,
							'max': max_amount.sale_value,
							'amount': amount
						});
					}
					break;

				default:
					reject({'message': 'Invalid state'});
			}
		});
	}

	changeAmount(amount) {
		let that = this;
		//console.log('changeAmount(%o)', amount, that.state);

		return new Promise((resolve, reject) => {
			$('#amount-custom-range-input')
				.closest('.form-group')
				.find('.form-text')
				.hide()
				.html('&nbsp;');

			if (that.ajax.get_received_amount) {
				that.ajax.get_received_amount.abort();
			}

			that.promise.validate_amount = that
				._validateAmount(amount, that.state.operator)
				.then((response) => {
					resolve(response);
				})
				.catch((response) => {
					reject(response);
				})
			;
		})
			.then((response) => {
				//console.log('changeAmount(%o).then(%o)', amount, response, that.state);
				that.fields.submit_holder.find('button[type=submit]').removeClass('disabled');

				// update url
				let new_url = that.base_url;
				new_url += '/' + encodeURIComponent(that.state.country.name);
				new_url += '/' + encodeURIComponent(that.state.operator.name);

				let params = {
					'destination': that.account_type === that.ACCOUNT_TYPES.PHONE
						? that.state.phone_number.prefix + that.state.phone_number.number
						: that.state.phone_number.number
				};

				if (that.o.banner_promo_code !== '') {
					params._banner = that.o.banner_promo_code;
				}

				if (that.state.operator.value_type === 'fixed') {
					that.state.amount = response.amount;
					params.amount = parseFloat(that.state.amount.local_value);
					that.fields.amount_banner_holder.show();

					Array.from(that.fields.amount_banner_content.getElementsByClassName('banner-content')).forEach((banner) => {
						if (banner.getAttribute('data-sale_value') === that.state.amount.sale_value) {
							banner.style.display = '';
						} else {
							banner.style.display = 'none';
						}
					});
				} else {
					that.state.amount = {
						'sale_value': response.amount
					};
					params.amount = parseFloat(that.state.amount.sale_value);

					$('#amount-custom-range-input')
						.val(that.state.amount.sale_value)
						.closest('.form-group')
						.find('.form-text')
						.show()
						.html(response.message);
				}

				window.history.replaceState(this.state, 'Title', s.url(new_url, params));

				if (that.fields.submit_message_holder) {
					that.fields.submit_message_holder.text('');
				}

				that.fields.form_fields.html('');

				let el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'product_data[country_code]';
				el.value = that.state.country.code;
				that.fields.form_fields.append(el);

				el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'product_data[recharge_type]';
				el.value = that.state.operator.recharge_type;
				that.fields.form_fields.append(el);

				el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'product_data[operator_id]';
				el.value = that.state.operator.id;
				that.fields.form_fields.append(el);

				el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'product_data[number]';
				if (that.account_type === that.ACCOUNT_TYPES.PHONE) {
					el.value = that.state.phone_number.prefix.replace('+', '') + that.state.phone_number.number;
				} else {
					el.value = that.state.phone_number.number;
				}
				that.fields.form_fields.append(el);

				el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'quantity';
				el.value = that.state.amount.sale_value;
				that.fields.form_fields.append(el);

				el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'product_data[product_identifier]';
				el.value = that.state.operator.product_identifier;
				that.fields.form_fields.append(el);

				el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'product_data[nickname]';
				el.value = '';
				that.fields.form_fields.append(el);

				el = document.createElement('input');
				el.type = 'hidden';
				el.name = 'product_data[sms_notify_message]';
				el.value = '';
				that.fields.form_fields.append(el);

				if (that.state.operator.supplier_operator_fields.length) {
					that.state.operator.supplier_operator_fields.forEach((field) => {
						const field_product_data = {
							'field_key': field.field_key,
							'name': field.name,
							'order': field.order,
							'required': field.required,
							'type': field.type,
							'label': field.label,
							'value': ''
						};

						if (that.account_type === that.ACCOUNT_TYPES.PHONE) {
							if (field.type === 'phone') {
								field_product_data.value = that.state.phone_number.prefix.replace('+', '') + that.state.phone_number.number;
							}
						} else {
							if (field.type === 'email' || field.type === 'nauta') {
								field_product_data.value = that.state.phone_number.number;
							}
						}

						let form_account_field = document.createElement('input');
						form_account_field.type = 'hidden';
						form_account_field.name = 'product_data[account_fields][]';
						form_account_field.value = JSON.stringify(field_product_data);
						that.fields.form_fields.append(form_account_field);
					});
				}
			})
			.catch((response) => {
				//console.log('changeAmount(%o).catch(%o)', amount, response, that.state);
				that.fields.submit_holder.find('button[type=submit]').addClass('disabled');
				that.fields.amount_banner_holder.hide();

				if (response.message) {
					$('#amount-custom-range-input')
						.closest('.form-group')
						.find('.form-text')
						.show()
						.html(response.message);
				}
			});
	}

	_updateCountryOperators(operator_groups) {
		//console.log('_updateCountryOperators(%o)', operator_groups);
		operator_groups.sort((a, b) => {
			if (typeof a.priority === 'undefined') {
				a.priority = 0;
			}

			if (typeof b.priority === 'undefined') {
				b.priority = 0;
			}

			if (a.priority < b.priority) {
				return 1;
			}

			if (a.priority > b.priority) {
				return -1;
			}

			return 0;
		});

		let that = this;
		that.fields.operator_content.removeClass('justify-content-center');

		if (that.fields.operator_banner_content) {
			that.fields.operator_banner_content.innerHTML = '';
		}

		let _i = 1;
		// add tello as fake operator for US on 4th position on mobilerecharge only, task #42981
		let fake_operator_index = null;
		if (this.add_tello_as_operator && this.add_tello_as_operator.position) {
			let keys = Object.keys(operator_groups);
			fake_operator_index = keys.length >= this.add_tello_as_operator.position ? this.add_tello_as_operator.position : keys.length;
		}
		for (let group_name in operator_groups) {
			if (fake_operator_index && _i == fake_operator_index && this.state.country.code == 'US') {
				let col = document.createElement('div');
				const operator_span_size = Math.floor(12 / that.o.operators_per_row);
				col.classList.add('col-6', 'col-md-4', 'col-lg-' + operator_span_size, 'fake', 'operator');
				let group = `
				<a href='${s.h(this.add_tello_as_operator.link)}' target='_blank' aria-label='${s.h(this.add_tello_as_operator.name)}' data-country='${s.h(this.add_tello_as_operator.name)}' 
				class='d-flex flex-column align-items-center justify-content-center mb-20 operator_button'>
					<div class='banner-icons-holder d-flex'>
						<svg class='banner-icon ml-5' data-banner_type='_index_mr_offer'><use xlink:href='#svg_icon-label--promo-new'></use></svg>
					</div>
					<div class='operator-logo d-flex flex-grow-1 justify-content-center align-items-center' style='min-height: 58px;'>
						<img src='${s.url(this.add_tello_as_operator.image_src)}' alt='${s.h(this.add_tello_as_operator.name)}' class='img-fluid'>
					</div>
				</a>`;
				let node = document.createRange().createContextualFragment(group);//convert string to Node element
				col.appendChild(node);
				that.fields.operator_content.append(col);
			}

			if (operator_groups.hasOwnProperty(group_name)) {
				let group_details = operator_groups[group_name];
				let group;
				let operator_banners = [];
				let banner_icons = document.createElement('div');
				let col = document.createElement('div');
				let group_logo = document.createElement('img');
				let icon_already_added = false;
				let show_more_operators_box = false;
				let _display_max_operators = null;

				if (that.o.location === 'hero') {
					_display_max_operators = that.o.mr_hero_max_operators;
				}
				if (that.o.location === 'hero_target') {
					_display_max_operators = that.o.target_hero_max_operators;
				}
				if (_display_max_operators && _i > _display_max_operators) {
					show_more_operators_box = true;
				}

				banner_icons.classList.add('banner-icons-holder', 'd-flex');

				const operator_span_size = Math.floor(12 / that.o.operators_per_row);
				col.classList.add('col-6', 'col-md-4', 'col-lg-' + operator_span_size, 'operator');

				group_logo.src = s.url('/images/operators/' + encodeURIComponent(group_details.logo) + '.jpg');
				group_logo.alt = s.h(group_details.name ? group_details.name : group_details.logo);
				group_logo.classList.add('img-fluid');

				let operators_select = false;
				if (group_details.operators.length > 1) {
					group = document.createElement('div');
					group.classList.add('justify-content-center');
					group_details.operators.sort((a, b) => {
						if (typeof a.priority === 'undefined') {
							a.priority = 0;
						}

						if (typeof b.priority === 'undefined') {
							b.priority = 0;
						}

						if (a.priority < b.priority) {
							return 1;
						}

						if (a.priority > b.priority) {
							return -1;
						}

						return 0;
					});

					if ('group' in group_details) {
						group.dataset.operatorGroup = group_details.group;
					}

					group.classList.add('d-flex', 'flex-column', 'align-items-center');

					group_details.operators.forEach((operator) => {
						operator_banners = that._getOperatorBanners(operator);
						operator_banners.forEach((banner) => {
							if (banner.icon) {
								icon_already_added = banner_icons.innerHTML && banner_icons.innerHTML.indexOf(banner.icon.innerHTML) > 0;
								if (!icon_already_added) {
									banner_icons.appendChild(banner.icon);
								}
							}
						});
					});
				} else {
					let operator = group_details.operators[0];
					// handle nauta
					if (operator.id == 84513198512158) {
						group = document.createElement('a');
						group.setAttribute('href', s.url('/buy/nauta'));
						group.classList.add('d-flex', 'flex-column', 'align-items-center');
					} else {
						group = document.createElement('button');
						group.value = operator.id;
						group.type = 'button';
					}
					group.setAttribute('aria-label', 'Operator: ' + operator.name);
					group.setAttribute('data-country', operator.country_name);
					group.setAttribute('data-operator-group', operator.group);
					group.setAttribute('data-operator-type', operator.operator_type);

					group.classList.add('justify-content-center');

					operator_banners = that._getOperatorBanners(operator);
					operator_banners.forEach(banner => {
						if (banner.icon) {
							icon_already_added = banner_icons.innerHTML && banner_icons.innerHTML.indexOf(banner.icon.innerHTML) > 0;
							if (!icon_already_added) {
								banner_icons.appendChild(banner.icon);
							}
						}
					});
				}

				group.classList.add('operator_button', 'mb-20');

				if (that.o.location === 'hero_target' && that.fields.all_operators_holder) {
					const operator_holder = document.createElement('div');
					const operator_link = document.createElement('a');
					const operator_image_holder = document.createElement('div');
					const operator_image = document.createElement('img');
					const operator_text = document.createElement('div');
					const operator_name = group_details.operators.length > 1 ? group_details.group : group_details.name;
					const operator_href = `/buy/mobile_recharge/${encodeURIComponent(s.options.preferred_destination)}/${encodeURIComponent(group_details.name)}`;

					operator_image.setAttribute('src', s.url(`/images/operators/${encodeURIComponent(group_details.logo)}.jpg`));
					operator_image.alt = s.h(operator_name);

					operator_image_holder.classList.add('operator-logo', 'd-flex', 'flex-grow-1', 'justify-content-center', 'align-items-center');
					operator_image_holder.style.minHeight = '58px';
					operator_image_holder.appendChild(operator_image);

					operator_text.classList.add('operator-name', 'color-black', 'mt-10');
					operator_text.innerText = s.it('MR_HOMEPAGE_RECHARGE_OPERATOR', {'operator' : operator_name});

					operator_link.classList.add('operator-link', 'd-flex', 'flex-column', 'text-center');
					operator_link.setAttribute('href', s.url(operator_href));
					operator_link.appendChild(operator_image_holder);
					operator_link.appendChild(operator_text);

					operator_holder.classList.add('operator', 'd-flex', 'align-items-center', 'mb-50');
					operator_holder.appendChild(operator_link);

					that.fields.all_operators_holder.append(operator_holder);
				}

				group.appendChild(banner_icons);
				group.appendChild(group_logo);

				if (operators_select !== false) {
					group.appendChild(operators_select);
				}

				if (show_more_operators_box) {
					col.classList.add('d-none');
				}

				if (_display_max_operators && _i > _display_max_operators - 1 && operator_groups.length > _display_max_operators) {
					// Only Show the "see more operators" button in case we have more than the predefined number of
					// displayed operators on a certain section
				} else {
					col.appendChild(group);
					that.fields.operator_content.append(col);
				}

				if (show_more_operators_box && _i === operator_groups.length) {
					let _selected_country = '';
					if (s.options.preferred_destination) {
						_selected_country = s.options.preferred_destination;
					}
					if (typeof that.state.country.name === 'string') {
						_selected_country = that.state.country.name;
					}
					let col_more = document.createElement('div');
					col_more.classList.add('col-6', 'col-md-4', 'more_operators');
					let more_group;
					more_group = document.createElement('a');
					more_group.setAttribute('href', s.url(`/buy/mobile_recharge/${_selected_country}`));
					more_group.classList.add(
						'd-flex', 'flex-column', 'align-items-center', 'justify-content-center',
						'mb-20', 'text-decoration-none', 'border', 'border-white'
					);
					more_group.style.height = '110px';
					let more_message = document.createElement('div');
					more_message.classList.add('color-white', 'text-center');
					more_message.innerText = s.it('MR_HOMEPAGE_MORE_OPERATORS');
					let more_arrow = document.createElement('div');
					more_arrow.innerHTML = s.svg('icon-arrow--xx-large',
						'0 0 58 68',
						['color-white'],
						{'width': '68px', 'height': '58px'}
					);
					more_group.append(more_message);
					more_group.append(more_arrow);
					col_more.append(more_group);
					that.fields.operator_content.append(col_more);
				}

				_i++;
			}
		}

		that.fields.operator_holder.show();
	}

	_resetFields() {
		try {
			this.fields.phone_number_holder.hide();
			this.fields.amount_holder.hide();
			this.fields.amount_banner_holder.hide();
			this.fields.send_sms_holder.hide();
			if(this.fields.operator_banner_content) {
				this.fields.operator_banner_content.innerHTML = '';
			}
			this.fields.submit_holder.find('button[type=submit]').addClass('disabled');
		} catch (error) {
			console.log('Error on _resetFields', error);
		}
	}

	_updateOperatorOptions(operator_group) {
		//console.log('_updateOperatorOptions(%o)', operator_groups);
		if(operator_group.operators.length === 1) {
			return;
		}

		const operators = operator_group.operators;
		operators.sort((a, b) => {
			if (typeof a.priority === 'undefined') {
				a.priority = 0;
			}
			if (typeof b.priority === 'undefined') {
				b.priority = 0;
			}
			if (a.priority < b.priority) {
				return 1;
			}
			if (a.priority > b.priority) {
				return -1;
			}
			return 0;
		});
		let that = this;
		that._resetFields();
		that.fields.operator_options_content.empty();
		that.fields.operator_options_content.removeClass('justify-content-center');

		if (that.fields.operator_banner_content) {
			that.fields.operator_banner_content.innerHTML = '';
		}

		let _i = 1;

		const group_details = operator_group;

		for (let operator_index in operators) {
			if (!operators.hasOwnProperty(operator_index)) {
				continue;
			}
			let operator = operators[operator_index];

			let group;
			let operator_banners = [];
			let banner_icons = document.createElement('div');
			let col = document.createElement('div');
			let group_logo_holder = document.createElement('div');
			let group_logo = document.createElement('img');
			let icon_already_added = false;
			banner_icons.classList.add('banner-icons-holder', 'd-flex');

			const operator_span_size = Math.floor(12 / that.o.operators_per_row);
			col.classList.add('col-6', 'col-md-4', 'col-lg-' + operator_span_size, 'operator');

			group_logo.classList.add('img-fluid');
			group_logo.src = s.url('/images/operators/' + encodeURIComponent(group_details.logo) + '.jpg');
			group_logo.alt = s.h(group_details.name ? group_details.name : group_details.logo);

			group_logo_holder.classList.add('operator-logo', 'd-flex', 'flex-grow-1', 'justify-content-center', 'align-items-center');
			group_logo_holder.style.minHeight = '58px';
			group_logo_holder.appendChild(group_logo);

			// handle nauta
			if (operator.id == 84513198512158) {
				group = document.createElement('a');
				group.setAttribute('href', s.url('/buy/nauta'));
				group.classList.add('d-flex', 'flex-column', 'align-items-center');
			} else {
				group = document.createElement('button');
				group.value = operator.id;
				group.type = 'button';
			}

			const operator_label = document.createElement('div');
			operator_label.innerHTML = operator.name.replace(operator.group, '').trim();
			operator_label.classList.add('operator_label');

			operator_banners = that._getOperatorBanners(operator);
			operator_banners.forEach(banner => {
				if (banner.icon) {
					icon_already_added = banner_icons.innerHTML && banner_icons.innerHTML.indexOf(banner.icon.innerHTML) > 0;
					if (!icon_already_added) {
						banner_icons.appendChild(banner.icon);
					}
				}
				if (that.fields.operator_banner_content) {
					that.fields.operator_banner_content.appendChild(banner.content);
				}
			});

			group.appendChild(banner_icons);
			group.appendChild(group_logo_holder);
			group.appendChild(operator_label);
			group.setAttribute('aria-label', 'Operator: ' + operator.name);
			group.setAttribute('data-country', operator.name);
			group.classList.add('operator_button', 'd-flex', 'flex-column', 'justify-content-center', 'align-items-center', 'px-0', 'mb-20');

			col.appendChild(group);
			that.fields.operator_options_content.append(col);

			// Back to operator groups
			if (_i === operators.length) {
				let col_back = document.createElement('div');
				col_back.classList.add('col-6', 'col-md-4', 'operators_back');
				let back_group;
				back_group = document.createElement('div');
				back_group.classList.add('d-flex', 'flex-column', 'align-items-center', 'justify-content-center',
					'mb-20', 'text-decoration-none', 'border',
					'text-center', 'border-white', 'cursor-pointer');
				back_group.style.height = '110px';
				let back_message = document.createElement('div');
				back_message.classList.add('back_text', 'color-white');
				back_message.innerText = that.o.operators_back_btn_text !== '' ? that.o.operators_back_btn_text : s.it('BACK');
				let back_arrow = document.createElement('div');
				let svg_color_fill = 'color-white';

				switch (that.o.location) {
					case 'send_page':
						back_message.innerHTML = '<span class="mb-20 text-center fs-16-fixed">' + s.it('RECHARGE_ANOTHER_OPERATOR') + '</span>';
						col_back.classList.add('col-lg-3');
						break;
					case 'hero':
						back_message.innerHTML = '<span class="mb-20 text-center fs-16-fixed">' + s.it('RECHARGE_ANOTHER_OPERATOR') + '</span>';
						col_back.classList.add('col-lg-4');
						break;
					case 'hero_target':
						back_message.innerHTML = '<span class="mb-20 text-center fs-16-fixed">' + s.it('RECHARGE_ANOTHER_OPERATOR') + '</span>';
						col_back.classList.add('col-lg-4');
						break;
					case 'buy_page':
						back_group.classList.remove('border-white');
						back_message.innerHTML = '<span class="btn-link mb-20 text-center fs-16-fixed">' + s.it('RECHARGE_ANOTHER_OPERATOR') + '</span>';
						col_back.classList.add('col-lg-3');
						svg_color_fill = 'color-primary';
						break;
					default:
						back_message.innerHTML = '<span class="btn-link mb-20 text-center fs-16-fixed">' + s.it('RECHARGE_ANOTHER_OPERATOR') + '</span>';
						col_back.classList.add('col-lg-3');
						break;
				}

				back_arrow.innerHTML = s.svg('icon-arrow--x-large', '0 0 36 41', [svg_color_fill], {
					'width': '41px',
					'height': '36px'
				});

				back_arrow.style.transform = 'rotate(180deg)';	// create arrow left
				back_message.classList.add('px-10');

				back_group.append(back_message);
				back_group.append(back_arrow);
				col_back.append(back_group);
				col_back.addEventListener('click', function () {
					$('.operator', that.fields.operator_content).removeClass('active inactive')
					that.fields.operator_options_content.hide();
					that.fields.operator_content.show();
					that._resetFields();

					let new_url='';
					if(that.o.location === 'send_page'){
						let country = ''
						 Object.values(that.c).some((cnt)=>{
							if(Array.isArray(cnt)){
								const operators = cnt[0].operators
								if(operators[0].country_name){
									country = operators[0].country_name;
								}
							}
							return Boolean(country)
						 });

						if(that.state.operator){
							new_url = '/send/recharge/' + encodeURIComponent( that.state.operator.country || country );
						}
						else {
							new_url = '/send/recharge/' + encodeURIComponent( country );
						}
					}else {
						new_url = '/buy/mobile_recharge/' + encodeURIComponent(that.state.country.name);
					}

					if (that.o.location === 'buy_page' || that.o.location === 'send_page') {
						$.each(that.fields.operator_content.find('.operator'), function (i, element) {
							$(element).removeClass('d-none');
						});
						$('#choose_another_operator').removeClass('active');

						that.state.operator = {};
						that.state.phone_number = {};
						window.history.replaceState(that.state, 'Title', s.url(new_url, {}));
					} else if (that.o.location === 'hero') {
						const submit_button = $(that.fields.submit_holder).find('a');
						submit_button.show();
						submit_button.attr('data-operator-name', '');
						submit_button.attr('data-country-name', that.state.country.name);
						submit_button.attr({
							href: s.url(new_url)
						});
					}
				})
				that.fields.operator_options_content.append(col_back);
			}

			_i++;
		}

		that.fields.operator_options_content.show();
	}

	_preSelectOperatorGroup(group_name = false, operator_id = false) {
		if (group_name && this.fields.operator_holder) {
			const op_group_el = $('div.operator_button[data-operator-group="' + group_name + '"]', this.fields.operator_holder).first();
			const op_el = $('.operator_button[data-operator-group="' + group_name + '"]', this.fields.operator_holder).first();
			if (op_group_el.length) {
				op_group_el.trigger('click');
			} else if (op_el) {
				// only 1 operator in the group
				op_el.trigger('click');
			}
		}

		if (operator_id && this.fields.operator_options_content) {
			const op_el = $('button.operator_button[value="' + operator_id + '"]', this.fields.operator_options_content).first();
			if (op_el.length) {
				op_el.trigger('click');
			}
		}
	}

	_findOperatorGroup(operator_groups, group_name) {
		try {
			let operator_group_index = false;
			operator_groups.filter((operator_group, og_index) => {
				if(operator_group.group === group_name) {
					operator_group_index = og_index;
					return true;
				}
			});
			return operator_groups[operator_group_index];
		} catch (error) {
			return false;
		}
	}

	_findOperatorGroupByOperatorId(operator_groups, operator_id) {
		try {
			let operator_group_index = false;
			operator_groups.filter((operator_group, og_index) => {
				return operator_group.operators.filter((operator, o_index) => {
					if (parseInt(operator.id) === parseInt(operator_id)) {
						operator_group_index = og_index
						return true;
					}
				})
			})
			return operator_groups[operator_group_index];
		} catch (error) {
			return false;
		}
	}

	_getAmountBanners(amount) {
		let that = this;
		//console.log('_getAmountBanners(%o)', amount, that.state);
		let amount_banners = [];

		if (that.fields.operator_banner_content) {
			that.fields.operator_banner_content.style.display = '';
		}

		if (amount.flags) {
			for (let banner_type in amount.flags) {
				if (amount.flags.hasOwnProperty(banner_type)) {
					if (banner_type === 'operator_outage') {
						const banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
						banner_icon.classList.add('banner-icon', 'ml-5');
						banner_icon.setAttribute('data-banner_type', banner_type);
						banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--notice"></use>';

						const banner_content = document.createElement('div');
						banner_content.classList.add('banner-content', 'mb-10');
						banner_content.setAttribute('data-sale_value', amount.sale_value);
						banner_content.style.display = 'none';
						banner_content.classList.add('banner-content-new-operator');
						banner_content.innerHTML += '<div class="banner-message">' + amount.flags[banner_type] + '</div>';

						amount_banners.push({
							'icon': banner_icon,
							'content': banner_content
						});
					}

					if (banner_type === 'best_offer') {
						const banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
						banner_icon.classList.add('banner-icon', 'ml-5');
						banner_icon.setAttribute('data-banner_type', banner_type);
						banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--bestdeal"></use>';

						amount_banners.push({
							'icon': banner_icon
						});
					}
				}
			}
		}

		if (amount.max_discount > 0) {
			let banner_icon;
			banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			banner_icon.classList.add('banner-icon', 'ml-5');
			banner_icon.setAttribute('data-banner_type', 'discount');
			banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';

			amount_banners.push({
				'icon': banner_icon,
				'content': ''
			});
		}

		return amount_banners;
	}

	_getOperatorBanners(operator) {
		let that = this;
		// console.log('_getOperatorBanners(%o)', operator, that.state);
		let operator_banners = [];

		if (that.fields.operator_banner_content) {
			that.fields.operator_banner_content.style.display = '';
		}

		if (operator.flags.banners) {
			for (let banner_type in operator.flags.banners) {
				if (operator.flags.banners.hasOwnProperty(banner_type)) {
					let banner_types = operator.flags.banners[banner_type];
					let valid_banner_type = true;
					let banner_track = {
						banner_type: '',
						banner_content: ''
					};

					banner_types.forEach((banner) => {
						let banner_icon;
						banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
						banner_icon.classList.add('banner-icon', 'ml-5');
						banner_icon.setAttribute('data-banner_type', banner_type);

						let banner_message = document.createElement('div');
						banner_message.classList.add('banner-message', 'flex-grow-1');
						banner_message.innerHTML = banner.message;

						let banner_content = document.createElement('div');
						banner_content.classList.add('banner-content', 'mb-10');
						banner_content.setAttribute('data-operator_id', operator.id);
						banner_content.style.display = 'none';

						if (typeof banner.terms !== 'undefined' && banner.terms !== '') {
							let unique_id = ((length) => {
								let result = '';
								let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
								let charactersLength = characters.length;
								for (let i = 0;i < length;i++) {
									result += characters.charAt(Math.floor(Math.random() * charactersLength));
								}

								return result;
							})(20);

							let chevron = s.svg('chevron-large-down',
								'0 0 24 24',
								['collapse-chevron', 'collapsed'],
								{},
								{
									'data-toggle': 'collapse',
									'href': '#' + unique_id,
									'role': 'button',
									'aria-expanded': 'false',
									'aria-controls': 'collapseExample'
								}
							);

							let banner_terms_holder = document.createElement('div');
							banner_terms_holder.classList.add('d-flex', 'align-items-center');
							banner_terms_holder.appendChild(banner_message);
							banner_terms_holder.innerHTML += chevron;

							let banner_terms = document.createElement('div');
							banner_terms.setAttribute('id', unique_id);
							banner_terms.classList.add('banner-terms', 'collapse');
							let banner_terms_wrapper = document.createElement('div');
							banner_terms_wrapper.classList.add('pt-10');
							banner_terms_wrapper.innerHTML = banner.terms;
							banner_terms.appendChild(banner_terms_wrapper);

							banner_content.appendChild(banner_terms_holder);
							banner_content.appendChild(banner_terms);
						} else {
							banner_content.appendChild(banner_message);
						}

						if (operator.country_code && operator.name && banner.message) {
							banner_track.banner_content = `${operator.country_code} - ${operator.name} - ${banner.message.substring(0, 20)}`;
						}
						switch (banner_type) {
							case '_index_mr_offer':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';
								banner_track.banner_type = 'Offer';
								break;

							case '_index_mr_offer_middle':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';
								banner_track.banner_type = 'Offer Middle';
								break;

							case '_index_mr_promo':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';
								banner_track.banner_type = 'Promo';
								break;

							case '_mr_notice':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--notice"></use>';
								banner_content.classList.add('banner-content-icon');
								banner_content.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24"><use xlink:href="#icon-various--info"></use></svg>');
								banner_track.banner_type = 'Notice';
								break;

							case '_mr_new_operator':
								banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--new"></use>';
								banner_track.banner_type = 'New operator';
								break;

							case '_mr_message':
								banner_icon = null;
								banner_content.classList.add('banner-content-icon');
								banner_content.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24"><use xlink:href="#icon-various--info"></use></svg>');
								banner_track.banner_type = 'Message';
								break;

							default:
								valid_banner_type = false;
						}

						if (valid_banner_type) {
							operator_banners.push({
								'icon': banner_icon,
								'content': banner_content
							});
							that.o.tracking_params.banners[operator.id] = banner_track;
						}
					});
				}
			}
		}

		return operator_banners;
	}

	_handleDisplayOperatorBanners(operator) {
		let that = this;
		// console.log('_handleDisplayOperatorBanners(%o)', operator, that.state);
		if (that.fields.operator_banner_content) {
			that.fields.operator_banner_content.innerHTML = '';

			const operator_banners = that._getOperatorBanners(operator);

			operator_banners.forEach((banner) => {
				if (that.fields.operator_banner_content) {
					that.fields.operator_banner_content.appendChild(banner.content);
				}
			});

			//show selected operator banner with all bundles
			Array.from(that.fields.operator_banner_content.getElementsByClassName('banner-content')).forEach((banner) => {
				if (parseInt(banner.getAttribute('data-operator_id')) === parseInt(operator.id)) {
					banner.style.display = '';
				} else {
					banner.style.display = 'none';
				}
			});
		}
	}

	_updatePreferredAmounts(operator) {
		let that = this;
		// console.log('_updatePreferredAmounts(%o)', operator, that.state);

		that.fields.amount_content.html('');
		if(that.fields.amount_banner_content){
			that.fields.amount_banner_content.innerHTML = '';
		}
		let key = 1;
		let title_key = 1;
		let is_mobile = false;
		switch (operator.value_type) {
			case 'fixed':
				// Show the best offer as the first value
				if (operator.values.length > 1) {
					operator.values.forEach((value, key) => {
						if (typeof value.flags.best_offer !== 'undefined' && value.flags.best_offer) {
							operator.values.splice(key, 1);
							operator.values.unshift(value);
						}
					});
				}

				operator.values.forEach((value) => {
					let top_part = document.createElement('div');
					let bottom_part = document.createElement('div');
					let col = document.createElement('div');
					let content = '';
					let promo_content = '';
					let group;
					top_part.classList.add('top-part', 'd-flex', 'flex-column', 'bundle-top');
					col.classList.add('col-6', 'mb-20');

					if (value.language_text_promo) {
						if (that.o.new_value_promo_format) {
							promo_content += `<div class='fs-14 mt-10'>${value.language_text_promo}</div>`;
						} else {
							promo_content += '<div class="fs-14 mt-10">+ ' + s.it('BONUS') + ':</div>';
							promo_content += '<div class="d-flex flex-column justify-content-center fs-16 font-weight-bold">';
							promo_content += value.language_text_promo;
							promo_content += '</div>';
						}
					}

					switch (operator.operator_type) {
						case 'internet':
						case 'gift_card':
						case 'credit':
							col.classList.add('col-md-4', 'col-lg-3');
							bottom_part.classList.add('bottom-part', 'd-flex', 'flex-column');

							group = document.createElement('button');
							group.setAttribute('disabled', true);
							group.value = value.local_value;
							group.type = 'button';
							//group.setAttribute('data-country', operator.name);
							group.classList.add('justify-content-center');
							group.classList.add('amount', 'd-flex', 'flex-column', 'align-items-stretch');

							content += '<span class="fs-14">' + s.it('AMOUNT_RECEIVED') + ':</span>';
							content += '<span class="fs-28 lh-1 mt-5">' + value.local_value + '</span>';
							content += '<span class="fs-14">' + value.local_currency.code + '</span>';
							break;

						case 'internet_bundle':
						case 'gift_card_bundle':
						case 'bundle':
							col.classList.remove('col-6');
							col.classList.add('col-12', 'col-sm-6');
							content += '<button type="button" onclick="return false;"';
							content += 'class="bundle_extra_toggle bundle_' + key + ' d-flex justify-content-between align-items-center cursor-pointer p-20';
							content += ' btn btn-link ';
							content += is_mobile === true ? '' : 'flipped_chevron' + '">';
							content += '<h3 class="mb-0 w-100">';
							content += value.title_text ? value.title_text : operator.name + ' #' + title_key;
							content += '</h3>';
							//if (value.language_text) {
							//	content += '<svg class="icon-animate-vertical icon-small toggle_chevron">';
							//	content += '<use xlink:href="#chevron-large-down"></use>';
							//	content += '</svg>';
							//}
							content += '</button>';
							if (value.language_text) {
								content += '<div class="bundle_language_var_' + key + ' collapse ' + (is_mobile === true ? '' : 'show');
								content += ' text-left px-20 pb-20 language_var_holder"' + (is_mobile === true ? '' : 'aria-expanded="true"');
								content += '>';
								content += '<div>';
								content += value.language_text;
								content += '</div>';
								content += promo_content;

								content += '</div>';
							}
							if (!value.title_text) {
								title_key++;
							}
							key++;
							break;

						default:
					}

					if (value.incl_taxes > 0) {
						content += '<span class="fs-10 mt-10">'
							+ s.it('INCLUDING_LOCAL_TAXES', {
								'amount_excluding_tax': s.format_money(
									value.incl_taxes,
									false,
									2,
									value.local_currency
								)
							})
							+ '</span>';
					}

					if (operator.operator_type === 'credit') {
						content += promo_content;
					}

					let existing_content = top_part.innerHTML;
					top_part.innerHTML = existing_content + content;

					bottom_part.classList.add('bottom-part', 'd-flex', 'flex-column');
					bottom_part.innerHTML = '<span class="fs-14">' + s.it('AMOUNT_CHARGED') + ':</span> '
						+ '<span class="fs-16">'
						+ (value.max_discount > 0 ? '<span class="fs-14 align-middle" style="text-decoration:line-through">' + s.format_money(value.sale_value)
							+ '</span> ' : '') + s.format_money(value.price) + '</span>';

					group = document.createElement('button');
					group.setAttribute('disabled', true);
					group.value = value.local_value;
					group.type = 'button';
					//group.setAttribute('data-country', operator.name);
					group.classList.add('justify-content-center');

					group.classList.add('amount', 'd-flex', 'flex-column', 'align-items-stretch');

					let banner_icons = document.createElement('div');
					banner_icons.classList.add('banner-icons-holder', 'd-flex');

					let operator_banners = that._getAmountBanners(value);
					operator_banners.forEach(banner => {
						if (banner.icon) {
							banner_icons.appendChild(banner.icon);
						}
						if (banner.content) {
							that.fields.amount_banner_content.appendChild(banner.content);
						}
					});

					group.appendChild(banner_icons);
					group.appendChild(top_part);
					group.appendChild(bottom_part);
					col.appendChild(group);

					that.fields.amount_content.append(col);
				});
				break;

			case 'range':
				let min_value = operator.values[0];
				let max_value = operator.values[1];
				let content = '<div class="col-sm col-lg-6">';
				content += '<div class="form-group mb-20">';
				content += '<div class="input-group">';
				content += '<div class="input-group-prepend">';
				content += '<span class="input-group-text">' + s.h(s.options.currency.code) + '</span>';
				content += '</div>';
				content += '<input id="amount-custom-range-input" type="number" class="form-control" step="any" ';
				content += 'min="' + s.h(min_value.sale_value) + '" max="' + s.h(max_value.sale_value) + '" ';
				content += 'aria-label="Recharge amount">';
				content += '</div>';
				content += '<div class="text-center">';
				content += '<img src="' + s.url('/images/app/spinner.gif') + '" class="spinner mt-5"  alt="Loading..." style="display:inline-block;height:24px">';
				content += '<small class="mt-5 fs-14 form-text text-muted"></small>';
				content += '</div>';
				content += '</div>';
				content += '</div>';

				//$('#amount-custom-range-input') = $('#amount-custom-range-input', that.fields.holder);

				that.fields.amount_content.append(content);
				$('.spinner', that.fields.amount_content).hide();
				break;

			default:
		}

		that.fields.amount_holder.show();
		that.fields.amount_banner_holder.show();
	}

	_sanitizePhoneNumber(phone_number) {
		return phone_number
			.replace(/[^\+0-9]/, '')
			.replace(/\^/, '')
			.replace(/]/, '');
	}

	_sanitizeAccountNumber(account) {
		return account.replace(/[^a-zA-Z0-9_.@-]+/g, '');
	}

	_formatPhoneExample(phone_number) {
		let that = this;
		let extra_numbers = '';
		let prefix = that._sanitizePhoneNumber(that.state.phone_number.prefix);
		phone_number = that._sanitizePhoneNumber(phone_number).replace(prefix, '');
		let new_number_mask = that.state.phone_number.mask
			.replace(that.state.phone_number.prefix, '')
			.replace(/-/gi, '')
			.replace(/[x_]/gi, '#')
			.replace(/[0-9]\?/gi, '#')
			.replace(/\[\^[0-9]]/gi, '#')
		;

		if (phone_number.length > new_number_mask.length) {
			extra_numbers = '<span style=\'color:red\'>' + phone_number.substring(new_number_mask.length, phone_number.length) + '</span>';
			phone_number = phone_number.substring(0, new_number_mask.length);
		}

		new_number_mask = phone_number + new_number_mask.substring(phone_number.length) + extra_numbers;

		return that.state.phone_number.prefix + '-' + new_number_mask;
	}

	_formatSMSPhoneExample(phone_number) {
		let that = this;
		let extra_numbers = '';
		let prefix = that._sanitizePhoneNumber(this.state.sms_phone_number.prefix);

		phone_number = that._sanitizePhoneNumber(phone_number).replace(prefix, '');
		let new_number_mask = this.state.sms_phone_number.mask
			.replace(prefix, '')
			.replace(/-/gi, '')
			.replace(/[x_]/gi, '#')
			.replace(/[0-9]\?/gi, '#')
			.replace(/\[\^[0-9]]/gi, '#')
		;

		if (phone_number.length > new_number_mask.length) {
			extra_numbers = '<span style=\'color:red\'>' + phone_number.substring(new_number_mask.length, phone_number.length) + '</span>';
			phone_number = phone_number.substring(0, new_number_mask.length);
		}

		new_number_mask = phone_number + new_number_mask.substring(phone_number.length) + extra_numbers;

		return this.state.sms_phone_number.prefix + '-' + new_number_mask;
	}

	// TODO re-write this trash thing
	_getSmsSize(text, max_sms) {
		max_sms = max_sms || 3;
		let
			limit,
			message_count,
			char_count,
			is_unicode = false,
			bytes = 0,
			doublebyte = '^{}\\[~]|'
		;

		if (text.length == 0) {
			return {
				'text': '',
				'char_count_left': 160,
				'message_count': 1
			};
		}

		for (let i = 0;i < text.length;i++) {
			if (text.charCodeAt(i) > 127)
				is_unicode = true;
			else if (text.charCodeAt(i) < 32 || doublebyte.indexOf(text.charAt(i)) >= 0)
				bytes += 2;
			else
				bytes++;
		}

		if (is_unicode) {
			bytes = text.length * 2;
			if (max_sms == 1)
				limit = 70;
			else
				limit = bytes <= 160 ? 70 : 67;
		} else {
			if (max_sms == 1)
				limit = 160;
			else
				limit = bytes <= 160 ? 160 : 153;
		}

		text = text.substr(0, limit * max_sms);

		message_count = Math.ceil(text.length / limit);
		char_count = limit * message_count - text.length;

		return {
			'text': text,
			'char_count_left': char_count,
			'message_count': message_count
		};
	}

	scrollToTarget(selector) {
		const target = document.querySelector(selector);
		if (target) {
			const navbar = document.querySelector('.navbar-kc');
			const navbar_info = navbar.getBoundingClientRect();
			const target_info = target.getBoundingClientRect();
			const offset = target_info.top - navbar_info.height;

			if (target_info.top >= 0 && target_info.bottom <= window.innerHeight) {
				// Element is in the viewport, no need to scroll
				return false;
			} else {
				window.scrollBy(0, offset);
				return true;
			}
		}
	}

	bindEvents() {
		let that = this;

		if (that.fields.form && that.fields.submit_holder) {
			that.fields.form.on('submit', function(event) {
				const submit_button = that.fields.submit_holder.find('button[type=submit]');
				if (submit_button.hasClass('disabled')) {
					event.preventDefault();
					submit_button.prop({disabled: false});
					that.fields.submit_message_holder.text('');
					if ($.isEmptyObject(that.state.operator.id)) {
						that.fields.submit_message_holder.text(s.it('MR_ERROR_MESSAGE_SELECT_OPERATOR'));
						s.track.event('Page Message', 'Buy MR Error Message', 'MR_ERROR_MESSAGE_SELECT_OPERATOR');
					} else {
						if (!that.state.phone_number.number) {
							that.fields.submit_message_holder.text(s.it('ENTER_PHONE_NUMBER_RECHARGE'));
							s.track.event('Page Message', 'Buy MR Error Message', 'ENTER_PHONE_NUMBER_RECHARGE');
						} else {
							if ($.isEmptyObject(that.state.amount)) {
								that.fields.submit_message_holder.text(s.it('SELECT_AMOUNT_SEND'));
								s.track.event('Page Message', 'Buy MR Error Message', 'SELECT_AMOUNT_SEND');
							}
						}
					}
				}
			});
		}
	}
}

// TODO change this to proper objects
$('body')
	.on('focus', '.form-control', function() {
		$(this)
			.closest('.input-group')
			.addClass('color-primary');
	})
	.on('blur', '.form-control', function() {
		$(this)
			.closest('.input-group')
			.removeClass('color-primary');
	});

//eslint-disable-next-line no-unused-vars
function triggerCollapse(key) {
	let button = $('.bundle_' + key);
	let can_trigger = !button.parent()
		.parent()
		.prop('disabled');
	if (can_trigger) {
		$('.bundle_language_var_' + key).collapse('toggle');
		button.toggleClass('flipped_chevron');
	}
}
